<template>
  <v-container>
    <v-dialog v-model="showSample" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark dense color="primary">
          <v-btn icon dark @click.native="showSample = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Sample Assessment</v-toolbar-title>
        </v-toolbar>
          <v-flex xs12 mb-5 class="assessment">
            <p>
                You appear to be a Mid-Level developer with a lot of technical skills who would benefit immensely from some
                small habit and communication changes.
            </p>

            <p>
                Your next area of focus should be executing on your daily plan consistently. Once you've established a
                routine of consistent execution, you should look at communicating more with your team and your manager.
            </p>

            <p>
                With your feature design skills, you can grow tremendously by analyzing requirements to
                design entire applications.
            </p>

            <p>
                Your career benefits from your reading, but you may want to dedicate a little more time and money to
                accelerate your growth. Buying courses and tools doesn't need to cost a lot, but
                the return on investment is huge.
            </p>
              <p>
                  The key to a higher bill rate is to convince prospects that you are the solution to all of their
                  problems, not just the ones they know about. There are a lot of freelancers who say,
                  'Give me the requirements and I'll write the code', but very few who say, 'Tell me where you
                  want to go and I'll get you there'. The value isn't in what the software does, the value is
                  in what the user can do with it.
              </p>
          </v-flex>
          <v-flex xs12 mb-5>
          <assessment-chart :datapoints="[2,3,4,2,2,2,2,1]"></assessment-chart>
          </v-flex>
      </v-card>
    </v-dialog>
      <v-dialog v-model="assessmentAvailable" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
              <v-toolbar dark dense color="primary">
                  <v-toolbar-title>Quick Assessment</v-toolbar-title>
              </v-toolbar>
              <div class="assessment">
                  <p>You appear to be a {{assessmentData.level}} developer with {{assessmentData.strength1}} who
                      {{assessmentData.strength2}}.</p>
                  <p>Your next area of focus should be {{assessmentData.focus1}}.  Once you've
                      {{assessmentData.focusEndstate}}, you should look at {{assessmentData.focus2}}. </p>
                  <p>{{assessmentData.designAnalysis}}</p>
                  <p>Your career {{assessmentData.careerInvest}}</p>
                  <p>{{assessmentData.careerPriority}}</p>
              </div>
              <div style="width: 90%;margin-top: 20px;">
                  <assessment-chart v-if="assessmentData.chartData" :datapoints="assessmentData.chartData"></assessment-chart>
              </div>
          </v-card>
      </v-dialog>
      <v-dialog v-model="showEmailForm" persistent max-width="450">
          <v-card>
              <v-card-title class="headline justify-center">Please enter your email address</v-card-title>
              <v-text-field ref="emailInput" label="Email" solo v-model="email"></v-text-field>
              <v-card-text>We'll send you info about Freelance Developer Coach and we won't share it with anyone. One-click unsubscribe anytime.</v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat @click.native="assess">Save</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    <v-layout wrap v-if="!assessmentAvailable && !showSample">

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3 text-xs-center">
          Welcome!
        </h1>
        <p class="subheading font-weight-regular text-xs-center">
          Answer the 10 questions below and click the Assess Me button to get your quick assessment and recommendations.<br/>
          The options are listed in order, so choose the response furthest down the list which applies to you. <br/>
          <v-layout justify-center>
            <v-btn round color="primary" dark v-on:click="displaySample">See a Sample</v-btn>
          </v-layout>
        </p>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">1. How long have you been a professional developer?</h2>
        <v-radio-group v-model="experience" column>
          <v-radio label="Less than 3 years" value="1"></v-radio>
          <v-radio label="Between 3 and 6 years" value="2"></v-radio>
          <v-radio label="Between 7 and 15 years" value="3"></v-radio>
          <v-radio label="More than 15 years" value="4"></v-radio>
        </v-radio-group>

      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">2. How many programming languages do you know?</h2>
          <v-radio-group v-model="languages" column>
            <v-radio label="Just what I need right now" value="1"></v-radio>
            <v-radio label="What I need now and some extra" value="2"></v-radio>
            <v-radio label="Enough to build anything I want" value="3"></v-radio>
            <v-radio label="More than I need and some I've forgotten" value="4"></v-radio>
          </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">3. What tools do you use for development?</h2>
        <v-radio-group v-model="tools" column>
          <v-radio label="A basic text editor like Notepad or Nano" value="1"></v-radio>
          <v-radio label="Editor with language highlighting like Sublime" value="2"></v-radio>
          <v-radio label="Emacs or other text-based dev tool" value="3"></v-radio>
          <v-radio label="IDE with debugging like Eclipse or PyCharm" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">4. How would you describe your work habits?</h2>
        <v-radio-group v-model="habits" column>
          <v-radio label="I just try to make it through each day" value="1"></v-radio>
          <v-radio label="I have a plan and usually stick to it" value="2"></v-radio>
          <v-radio label="I have a plan and stick to it every day" value="3"></v-radio>
          <v-radio label="I teach others good work habits" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">5. How well do you work on a team?</h2>
        <v-radio-group v-model="teamwork" column>
          <v-radio label="I don't work well with others" value="1"></v-radio>
          <v-radio label="I can work with others, but prefer not to" value="2"></v-radio>
          <v-radio label="I quickly fit into the teams I join" value="3"></v-radio>
          <v-radio label="I'm a leader on the teams I join" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">6. What is it like to manage you?</h2>
        <v-radio-group v-model="management" column>
          <v-radio label="I do what I'm told, but that's it" value="1"></v-radio>
          <v-radio label="I provide status reports, but only when asked" value="2"></v-radio>
          <v-radio label="My manager can see my status without asking" value="3"></v-radio>
          <v-radio label="My team can easily see all my work and status" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">7. How skilled are you at design and analysis?</h2>
        <v-radio-group v-model="designAndAnalysis" column>
          <v-radio label="Someone else needs to design what I build" value="1"></v-radio>
          <v-radio label="I can help design features of an application" value="2"></v-radio>
          <v-radio label="I can design applications from requirements" value="3"></v-radio>
          <v-radio label="I can design distributed systems by myself" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">8. How are your communication skills?</h2>
        <v-radio-group v-model="communication" column>
          <v-radio label="I tend to only speak when spoken to" value="1"></v-radio>
          <v-radio label="I will ask others about the project " value="2"></v-radio>
          <v-radio label="I will discuss potential problems I see" value="3"></v-radio>
          <v-radio label="I will alert to problems that I cause" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">9. How much do you invest in your career growth?</h2>
        <v-radio-group v-model="growth" column>
          <v-radio label="I spend my time on execution, not growth" value="1"></v-radio>
          <v-radio label="I spend some time reading about growth" value="2"></v-radio>
          <v-radio label="I allocate time and money for my growth" value="3"></v-radio>
          <v-radio label="I spend all the time/money I can on growth" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">10. What's your top career priority?</h2>
        <v-radio-group v-model="priority" column>
          <v-radio label="I don't have a priority" value="1"></v-radio>
          <v-radio label="I want to make my clients happier" value="2"></v-radio>
          <v-radio label="I want to increase my bill rate" value="3"></v-radio>
          <v-radio label="I want more clients and projects" value="4"></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs12 mb-6>
        <v-layout justify-center>
          <v-btn round color="primary" dark v-on:click="assess">Assess Me</v-btn>
        </v-layout>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import AssessmentChart from "./AssessmentChart"
  import axios from 'axios'

  export default {
      components: {AssessmentChart},
      created() {
          let uri = window.location.search.substring(1);
          let params = new URLSearchParams(uri);
          this.email = params.get("email");
          window.history.pushState("", "", "/");
      },
      mounted() {
      },
    data() {
        return {
            experience: "1",
            languages: "1",
            tools: "1",
            habits: "1",
            teamwork: "1",
            management: "1",
            designAndAnalysis: "1",
            communication: "1",
            growth: "1",
            priority: "1",
            assessmentAvailable: false,
            showSample: false,
            showEmailForm: false,
            assessmentData: {},
            email: ""
        }
    },
    methods: {
      assess() {
          this.showEmailForm = false
          if (this.email == null || this.email == "") {
              this.showEmailForm = true;
              setTimeout(this.$refs.emailInput.focus, 500)
              return;
          }
          const data = {
              "email": this.email, "experience": this.experience, "languages": this.languages, "tools": this.tools,
              "habits": this.habits, "teamwork": this.teamwork, "management": this.management,
              "designAndAnalysis": this.designAndAnalysis, "communication": this.communication, "growth": this.growth,
              "priority": this.priority
          }
          axios.defaults.baseURL = 'https://enxrwq31y7.execute-api.us-east-1.amazonaws.com/dev';
          axios.defaults.headers.post['Content-Type'] = 'application/json';

          axios.post('/survey', data).then(response => {
              this.assessmentData = response.data
              this.assessmentAvailable = true
          })

      },
      displaySample() {
        this.showSample = true
      }
    }
  }
</script>

<style>
.assessment {
    margin-left: 50px;
    margin-right: 50px;
    border: 1px solid black;
    margin-top: 10px;
    background: white;

    padding: 10px;
}
</style>
